var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.btnType,{tag:"component",attrs:{"title":_vm.title,"href":_vm.ahref,"data-sv-button":""},on:{"click":_vm.debouncedFunction}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }